app-email-thread-container{display:flex;width:100%;height:100%}app-email-thread-container .email-thread-container .thread-email{margin-bottom:20px}app-email-thread-container .email-thread-container .thread-email:last-child{margin-bottom:0}
/*# sourceMappingURL=email-thread-container.component-57UACXHN.css.map */
